import { Badge } from '@/components/ui/badge';
import { Checkbox } from '@/components/ui/checkbox';
import { OverviewSectionCard } from '@/components/agent/overview/OverviewSectionCard';
import { OverviewSettingRow } from '@/components/agent/overview/OverviewSettingRow';
import { ChannelConfig, CHANNEL_OPTIONS, ChannelType } from '@/types/activation/activation-pack';

interface PackChannelsSectionProps {
  channels: ChannelConfig;
  isEditing?: boolean;
  onEditToggle?: () => void;
  onChannelToggle: (key: ChannelType) => void;
  brand?: string;
  disabled?: boolean;
}

export const PackChannelsSection = ({
  channels,
  isEditing = false,
  onEditToggle,
  onChannelToggle,
  brand = '#4E9CFF',
  disabled = false,
}: PackChannelsSectionProps) => {
  const enabledChannels = CHANNEL_OPTIONS.filter((c) => channels[c.value]);

  return (
    <OverviewSectionCard
      title="Contact Channels"
      subtitle="How customers can reach your genie or portal"
      genieIcon="eye"
      brand={brand}
      onEdit={disabled ? undefined : onEditToggle}
    >
      {disabled ? (
        <div className="text-sm text-gray-500 italic py-4">
          Select a target above to configure channels
        </div>
      ) : isEditing ? (
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            How should customers reach your genie or portal?
          </p>
          {CHANNEL_OPTIONS.map((option) => (
            <div
              key={option.value}
              className="flex items-start space-x-3 p-4 rounded-lg border border-gray-200 hover:border-primary/50 transition-colors cursor-pointer"
              onClick={() => onChannelToggle(option.value)}
            >
              <Checkbox
                checked={channels[option.value]}
                onCheckedChange={() => onChannelToggle(option.value)}
              />
              <div>
                <div className="font-medium">{option.label}</div>
                <div className="text-sm text-muted-foreground">{option.description}</div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="space-y-4">
          <OverviewSettingRow
            label="Active Channels"
            value={
              enabledChannels.length > 0 ? (
                <div className="flex flex-wrap gap-2 justify-end">
                  {enabledChannels.map((c) => (
                    <Badge
                      key={c.value}
                      className="bg-primary/10 text-primary border-0"
                    >
                      {c.label}
                    </Badge>
                  ))}
                </div>
              ) : (
                <span className="text-gray-500 italic">No channels selected</span>
              )
            }
          />
        </div>
      )}
    </OverviewSectionCard>
  );
};
